import { Button, Checkbox, EmailInput, Heading, TwoColumnGrid } from "@RooUI";
import React from "react";

import { PasswordInput } from "../../../Common/Form/PasswordInput";
import { PhoneInput } from "../../../Common/Form/PhoneInput";
import { RegisterCTAText } from "../../../Common/Form/RegisterCTAText";
import { FormContainer, FormFields, FormHeader } from "../Common/styles";
import { ButtonContainer } from "../RegistrationPageContainer/styles";

import { useFormContext } from "./RegistrationSignUpFormContext";

export const RegistrationSignUpForm = () => {
  const {
    onChange,
    onSave,
    loading,
    errors,
    // @ts-expect-error TS2339
    form: { email, password, phone, isMarketingSMSEnabled = false },
  } = useFormContext();

  return (
    <FormContainer>
      <FormHeader>
        <Heading level={3}>How can we contact you?</Heading>
      </FormHeader>
      <FormFields>
        <TwoColumnGrid>
          <EmailInput
            label="Email"
            value={email}
            onChange={(email) => {
              // @ts-expect-error TS2722
              onChange("email", email);
            }}
            // @ts-expect-error TS18048
            error={errors["email"]}
            name="email"
          />
          <PasswordInput
            password={password}
            // @ts-expect-error TS18048
            error={errors["password"]}
            // @ts-expect-error TS2722
            onChange={(value) => onChange("password", value)}
          />
        </TwoColumnGrid>
        <TwoColumnGrid>
          <PhoneInput
            label="Phone number"
            value={phone}
            // @ts-expect-error TS18048
            error={errors["phone"]}
            placeholder="Enter your mobile number"
            // @ts-expect-error TS2722
            onChange={(phone) => onChange("phone", phone)}
            id="mobileInput"
            data-testid="mobileInput"
          />
        </TwoColumnGrid>

        <Checkbox
          topAlignedLabel
          label="I agree to receive recurring marketing text messages from Roo at the phone number provided. Msg & data rates may apply. Msg frequency varies. Reply HELP for help and STOP to cancel."
          checked={isMarketingSMSEnabled}
          onChange={() => {
            // @ts-expect-error TS2722
            onChange("isMarketingSMSEnabled", !isMarketingSMSEnabled);
          }}
          data-testid="marketingSmsToggle"
        />
      </FormFields>
      <RegisterCTAText />
      <ButtonContainer>
        <Button
          $buttonType="primary"
          title="Create My Account"
          onClick={onSave}
          loading={loading}
          data-testid="createAccountBtn"
        />
      </ButtonContainer>
    </FormContainer>
  );
};
